const LOCAL_WORKER_URL = 'http://127.0.0.1:7730';
const WORKER_URL_STORAGE_KEY = 'sofronios_worker_url';

function readStoredWorkerUrl(): string | null {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(WORKER_URL_STORAGE_KEY);
}

export function getStoredWorkerUrl(
  fallback: string,
  storedValue: string | null = readStoredWorkerUrl(),
): string {
  return (storedValue && storedValue.trim()) || fallback;
}

export function getWorkerBaseUrl(hostname?: string, origin?: string): string {
  const host = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');
  const pageOrigin = origin ?? (typeof window !== 'undefined' ? window.location.origin : '');
  let fallback = LOCAL_WORKER_URL;

  if (host && !['localhost', '127.0.0.1'].includes(host)) {
    fallback = pageOrigin;
  }

  // Marketplace instances (*.lokalbase.app) must use same-origin GraphQL — never a stale
  // localStorage override (which would point at a DB with no seeded users).
  if (host.endsWith('.lokalbase.app')) {
    return fallback;
  }

  return getStoredWorkerUrl(fallback);
}

export function getWorkerGraphqlUrl(hostname?: string, origin?: string): string {
  return `${getWorkerBaseUrl(hostname, origin).replace(/\/$/, '')}/graphql`;
}
